import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../app/ThemeProvider';
import Logo from '../../assets/images/logo.png';
import LogoLight from '../../assets/images/logo_light.png';
import Footer from '../../layout/Footer';
import { ArrowRight, MapPin, Sparkles, Users, Layers, Activity, User, Video, Mic, Image as ImageIcon, Music, Camera, Palette } from 'lucide-react';
import './LandingPage.css';

const BentoMockup = ({ type, className = "" }) => {
  const renderContent = () => {
    switch (type) {
      case 'profile':
        return (
          <>
            <h5 className="fw-bold fs-4 mb-2" style={{ color: 'var(--text-primary)' }}>Showcase Your Talent</h5>
            <div className="mockup-inner-3d flex-grow-1 d-flex flex-column rounded-4 overflow-hidden mt-2" style={{ background: 'var(--panel-bg)' }}>
              <div style={{ height: '70px', background: 'linear-gradient(135deg, var(--accent), #9333ea)', position: 'relative' }}>
                <div className="position-absolute" style={{ bottom: '-15px', left: '16px' }}>
                  <div className="bg-dark rounded-circle d-flex align-items-center justify-content-center" style={{ width: '44px', height: '44px', border: '3px solid var(--panel-bg)' }}>
                    <User size={20} color="white" />
                  </div>
                </div>
              </div>
              <div className="px-3 pt-4 pb-3 d-flex flex-column flex-grow-1">
                <h6 className="fw-bold mb-0" style={{ color: 'var(--text-primary)' }}>Alex Rivera</h6>
                <p className="text-muted mb-3" style={{ fontSize: '10px' }}>@alex_creates • Digital Artist</p>

                <div className="d-flex gap-3 border-bottom pb-2 mb-3" style={{ borderColor: 'var(--border-color)' }}>
                  <span className="fw-bold border-bottom border-2 pb-2" style={{ fontSize: '10px', color: 'var(--text-primary)', borderColor: 'var(--accent) !important' }}>Portfolio</span>
                  <span className="text-muted" style={{ fontSize: '10px' }}>Posts</span>
                  <span className="text-muted" style={{ fontSize: '10px' }}>About</span>
                </div>

                <div className="mockup-portfolio-grid mt-auto">
                  <div className="mockup-inner-3d portfolio-item item-1 d-flex align-items-center justify-content-center mockup-item-anim mockup-delay-1" style={{ height: 54 }}><Video size={18} color="#4f46e5" /></div>
                  <div className="mockup-inner-3d portfolio-item item-2 d-flex align-items-center justify-content-center mockup-item-anim mockup-delay-2" style={{ height: 54 }}><ImageIcon size={18} color="#9333ea" /></div>
                  <div className="mockup-inner-3d portfolio-item item-3 d-flex align-items-center justify-content-center mockup-item-anim mockup-delay-3" style={{ height: 54 }}><Mic size={18} color="#ea580c" /></div>
                  <div className="mockup-inner-3d portfolio-item item-4 d-flex align-items-center justify-content-center mockup-item-anim mockup-delay-1" style={{ height: 54 }}><Music size={18} color="#ca8a04" /></div>
                  <div className="mockup-inner-3d portfolio-item item-5 d-flex align-items-center justify-content-center mockup-item-anim mockup-delay-2" style={{ height: 54 }}><Camera size={18} color="#16a34a" /></div>
                  <div className="mockup-inner-3d portfolio-item item-6 d-flex align-items-center justify-content-center mockup-item-anim mockup-delay-3" style={{ height: 54 }}><Palette size={18} color="#db2777" /></div>
                </div>
              </div>
            </div>
          </>
        );
      case 'grant':
        return (
          <>
            <h5 className="fw-bold fs-4 mb-2" style={{ color: 'var(--text-primary)' }}>Level Up</h5>
            <p className="text-muted small mb-3">Discover grants and funding for your next big idea.</p>
            <div className="d-flex flex-column gap-3 mt-2">
              <div className="mockup-inner-3d mockup-grant-card p-3 mockup-item-anim mockup-delay-1">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div className="d-flex align-items-center gap-2">
                    <div className="mockup-grant-icon" style={{ width: 28, height: 28 }}><Activity size={14} color="white" /></div>
                    <span className="fw-bold fs-6" style={{ color: 'var(--text-primary)' }}>Creative Grant</span>
                  </div>
                  <span className="fw-bold text-success bg-success bg-opacity-10 px-2 py-1 rounded-pill" style={{ fontSize: '0.75rem' }}>$2,500</span>
                </div>
                <div className="d-flex justify-content-between align-items-end mt-2">
                  <div>
                    <p className="mb-0 text-muted" style={{ fontSize: '0.75rem' }}>Arts Council</p>
                  </div>
                </div>
              </div>

              <div className="mockup-inner-3d mockup-grant-card p-3 mockup-item-anim mockup-delay-2">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div className="d-flex align-items-center gap-2">
                    <div className="mockup-grant-icon bg-warning" style={{ width: 28, height: 28 }}><Sparkles size={14} color="white" /></div>
                    <span className="fw-bold fs-6" style={{ color: 'var(--text-primary)' }}>Mural Project</span>
                  </div>
                  <span className="fw-bold text-success bg-success bg-opacity-10 px-2 py-1 rounded-pill" style={{ fontSize: '0.75rem' }}>$5,000</span>
                </div>
                <div className="d-flex justify-content-between align-items-end mt-2">
                  <div>
                    <p className="mb-0 text-muted" style={{ fontSize: '0.75rem' }}>City of Kelowna</p>
                  </div>
                </div>
              </div>

              <div className="mockup-inner-3d mockup-grant-card p-3 mockup-item-anim mockup-delay-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div className="d-flex align-items-center gap-2">
                    <div className="mockup-grant-icon bg-info" style={{ width: 28, height: 28 }}><Users size={14} color="white" /></div>
                    <span className="fw-bold fs-6" style={{ color: 'var(--text-primary)' }}>Studio Residency</span>
                  </div>
                  <span className="fw-bold text-success bg-success bg-opacity-10 px-2 py-1 rounded-pill" style={{ fontSize: '0.75rem' }}>$1,500</span>
                </div>
              </div>
            </div>
          </>
        );
      case 'collab':
        return (
          <>
            <h5 className="fw-bold fs-4 mb-2" style={{ color: 'var(--text-primary)' }}>Connect & Collaborate</h5>
            <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom" style={{ borderColor: 'var(--border-color)' }}>
              <div className="d-flex align-items-center gap-2">
                <div className="mockup-avatar bg-dark text-white d-flex align-items-center justify-content-center fw-bold" style={{ width: 28, height: 28 }}>#</div>
                <span className="fw-bold small" style={{ color: 'var(--text-primary)' }}>project-alpha</span>
              </div>
              <span className="text-muted small">3 members</span>
            </div>
            <div className="d-flex flex-column gap-3 flex-grow-1 position-relative mb-3">
              <div className="mockup-inner-3d mockup-message left mockup-item-anim mockup-delay-1">
                <div className="mockup-avatar bg-primary text-white d-flex align-items-center justify-content-center fw-bold">J</div>
                <div className="mockup-msg-content">
                  <div className="d-flex align-items-baseline gap-2">
                    <span className="fw-bold small" style={{ color: 'var(--text-primary)' }}>Julian</span>
                    <span className="text-muted" style={{ fontSize: '9px' }}>10:42 AM</span>
                  </div>
                  <p className="mb-0 fw-medium small" style={{ color: 'var(--text-primary)' }}>Just uploaded the new cuts. Let me know what you think!</p>
                </div>
              </div>
              <div className="mockup-inner-3d mockup-message right mockup-item-anim mockup-delay-2">
                <div className="mockup-msg-content text-end">
                  <div className="d-flex align-items-baseline justify-content-end gap-2">
                    <span className="text-muted" style={{ fontSize: '9px' }}>10:45 AM</span>
                    <span className="fw-bold small" style={{ color: 'var(--text-primary)' }}>You</span>
                  </div>
                  <p className="mb-0 fw-medium small" style={{ color: 'var(--text-primary)' }}>Looks solid! The color grading is insane.</p>
                </div>
                <div className="mockup-avatar bg-success text-white d-flex align-items-center justify-content-center fw-bold">Y</div>
              </div>
              <div className="mockup-inner-3d mockup-message left mockup-item-anim mockup-delay-3">
                <div className="mockup-avatar bg-info text-white d-flex align-items-center justify-content-center fw-bold">K</div>
                <div className="mockup-msg-content">
                  <div className="d-flex align-items-baseline gap-2">
                    <span className="fw-bold small" style={{ color: 'var(--text-primary)' }}>Kelsey</span>
                    <span className="text-muted" style={{ fontSize: '9px' }}>10:50 AM</span>
                  </div>
                  <p className="mb-0 fw-medium small" style={{ color: 'var(--text-primary)' }}>I'll add the backing track tonight 🎸</p>
                </div>
              </div>
            </div>
            <div className="mockup-inner-3d p-2 px-3 rounded-pill d-flex align-items-center justify-content-between mt-auto mockup-item-anim mockup-delay-4" style={{ background: 'var(--surface-muted)' }}>
              <span className="text-muted small">Message project-alpha...</span>
              <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center shadow-sm" style={{ width: 24, height: 24 }}>
                <ArrowRight size={14} color="white" />
              </div>
            </div>
          </>
        );
      case 'niche':
        return (
          <>
            <h5 className="fw-bold fs-4 mb-2" style={{ color: 'var(--text-primary)' }}>Find Your Niche</h5>
            <div className="d-flex flex-wrap gap-2 mt-3 mb-4">
              <span className="mockup-inner-3d mockup-pill-tag d-flex align-items-center gap-2 mockup-item-anim mockup-delay-1">
                <Music size={14} className="text-primary" /> Music Production <span className="badge bg-primary rounded-pill">1.2k</span>
              </span>
              <span className="mockup-inner-3d mockup-pill-tag d-flex align-items-center gap-2 mockup-item-anim mockup-delay-2">
                <Palette size={14} className="text-danger" /> Digital Art <span className="badge bg-danger rounded-pill">840</span>
              </span>
              <span className="mockup-inner-3d mockup-pill-tag d-flex align-items-center gap-2 mockup-item-anim mockup-delay-3">
                <Video size={14} className="text-info" /> Filmmaking <span className="badge bg-info rounded-pill">650</span>
              </span>
              <span className="mockup-inner-3d mockup-pill-tag d-flex align-items-center gap-2 mockup-item-anim mockup-delay-1">
                <Layers size={14} className="text-warning" /> Graphic Design <span className="badge bg-warning rounded-pill">3.4k</span>
              </span>
              <span className="mockup-inner-3d mockup-pill-tag d-flex align-items-center gap-2 mockup-item-anim mockup-delay-2">
                <Camera size={14} className="text-success" /> Photography <span className="badge bg-success rounded-pill">2.1k</span>
              </span>
              <span className="mockup-inner-3d mockup-pill-tag d-flex align-items-center gap-2 mockup-item-anim mockup-delay-3">
                <Sparkles size={14} style={{ color: '#9333ea' }} /> Web3 Creators <span className="badge rounded-pill" style={{ backgroundColor: '#9333ea' }}>420</span>
              </span>
            </div>
            <div className="mockup-inner-3d p-3 rounded-4 mt-auto mockup-item-anim mockup-delay-4" style={{ background: 'var(--surface-muted)' }}>
              <div className="d-flex align-items-center justify-content-between mb-3">
                <span className="fw-bold small" style={{ color: 'var(--text-primary)' }}>Trending Community</span>
                <Activity size={14} className="text-success" />
              </div>
              <div className="d-flex align-items-center gap-3">
                <div className="bg-dark rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center" style={{ width: 44, height: 44 }}>
                  <span className="fs-3">🎥</span>
                </div>
                <div>
                  <h6 className="fw-bold mb-1" style={{ color: 'var(--text-primary)' }}>Indie Filmmakers</h6>
                  <p className="text-muted small mb-0">15 active discussions</p>
                </div>
              </div>
            </div>
          </>
        );
      case 'map':
        return (
          <>
            <h5 className="fw-bold fs-4 mb-2 position-relative z-1" style={{ color: 'var(--text-primary)' }}>Explore Local Resources</h5>
            <p className="text-muted small mb-3 position-relative z-1">Find studios, venues, and gear near you.</p>

            <div className="flex-grow-1 position-relative rounded-4 overflow-hidden mt-2 border" style={{ borderColor: 'var(--border-color)', background: 'var(--surface-muted)' }}>
              {/* Map Background Pattern */}
              <div className="position-absolute" style={{
                inset: 0,
                background: `
                   radial-gradient(circle at 30% 30%, rgba(156, 163, 175, 0.2) 2px, transparent 2px),
                   radial-gradient(circle at 70% 60%, rgba(156, 163, 175, 0.2) 2px, transparent 2px)
                 `,
                backgroundSize: '40px 40px',
              }}>
                {/* Fake Street lines */}
                <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" style={{ position: 'absolute', top: 0, left: 0 }}>
                  <path d="M-10,20 Q40,60 120,40 M-20,80 Q50,110 150,70 M40,-10 L70,120 M80,-10 L110,120" stroke="rgba(156, 163, 175, 0.2)" strokeWidth="3" fill="none" />
                </svg>
              </div>

              {/* Map Pins */}
              <div className="position-absolute mockup-item-anim mockup-delay-1" style={{ top: '25%', left: '30%', transform: 'translate(-50%, -50%)' }}>
                <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center shadow mx-auto" style={{ width: '36px', height: '36px', border: '3px solid white' }}>
                  <Mic size={16} />
                </div>
                <div className="bg-white rounded shadow-sm px-2 py-1 mt-1 text-center fw-bold text-dark" style={{ fontSize: '10px', whiteSpace: 'nowrap' }}>Recording Studio</div>
              </div>

              <div className="position-absolute mockup-item-anim mockup-delay-2" style={{ top: '65%', left: '75%', transform: 'translate(-50%, -50%)' }}>
                <div className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center shadow mx-auto" style={{ width: '36px', height: '36px', border: '3px solid white' }}>
                  <Palette size={16} />
                </div>
                <div className="bg-white rounded shadow-sm px-2 py-1 mt-1 text-center fw-bold text-dark" style={{ fontSize: '10px', whiteSpace: 'nowrap' }}>Art Gallery</div>
              </div>

              <div className="position-absolute mockup-item-anim mockup-delay-3" style={{ top: '80%', left: '35%', transform: 'translate(-50%, -50%)' }}>
                <div className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center shadow mx-auto" style={{ width: '36px', height: '36px', border: '3px solid white' }}>
                  <Camera size={16} />
                </div>
                <div className="bg-white rounded shadow-sm px-2 py-1 mt-1 text-center fw-bold text-dark" style={{ fontSize: '10px', whiteSpace: 'nowrap' }}>Gear Rental</div>
              </div>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div className={`bento-container mockup-bento ${className}`}>
      {renderContent()}
    </div>
  );
};

/**
 * Array of phrases used in the hero section typing animation.
 */
const PHRASES = [
  "the future of creativity.",
  "community.",
  "access.",
  "Circuit."
];

/**
 * TypingEffect Component
 */
const TypingEffect = () => {
  const [text, setText] = useState('');
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const currentPhrase = PHRASES[phraseIndex];
    if (!currentPhrase) return;

    const isFinalPhrase = phraseIndex === PHRASES.length - 1;
    const isFullyTyped = text === currentPhrase;
    const isFullyDeleted = text === '';

    if (isFinalPhrase && !isDeleting && isFullyTyped) {
      return;
    }

    let timer;

    if (isFullyTyped && !isDeleting) {
      timer = setTimeout(() => {
        setIsDeleting(true);
      }, 1500);
    } else if (isFullyDeleted && isDeleting) {
      setIsDeleting(false);
      setPhraseIndex((prev) => prev + 1);
    } else {
      const nextSpeed = isDeleting ? 40 : 100 - Math.random() * 50;
      timer = setTimeout(() => {
        setText(currentPhrase.substring(0, text.length + (isDeleting ? -1 : 1)));
      }, nextSpeed);
    }

    return () => clearTimeout(timer);
  }, [text, isDeleting, phraseIndex]);

  const isFinalState = phraseIndex === PHRASES.length - 1 && text === PHRASES[phraseIndex];

  return (
    <span className="text-center d-inline-block lp-typing-base" style={{ whiteSpace: 'nowrap' }}>
      {isFinalState ? <strong>{text}</strong> : text}
      <span
        className="lp-typing-caret"
        style={{
          animation: isFinalState ? 'none' : 'blink-caret .75s step-end infinite',
          opacity: isFinalState ? 0 : 1
        }}
      ></span>
    </span>
  );
};

export default function LandingPage() {
  const { theme } = useTheme();
  const [activeFeature, setActiveFeature] = useState(0);

  const features = [
    {
      icon: <Users size={32} />,
      title: "Connect & Collaborate",
      desc: "Whether you are a musician, videographer, or filmmaker, find like-minded creatives to build with. Stay plugged into the latest happenings across the industry.",
      type: "collab"
    },
    {
      icon: <Layers size={32} />,
      title: "Find Your Niche",
      desc: "Join or create specialized communities to dive deeper into your craft and learn from a network of skilled peers.",
      type: "niche"
    },
    {
      icon: <Sparkles size={32} />,
      title: "Level Up Your Career",
      desc: "Discover and track high-value opportunities, from local showcases to project grants, all in one centralized hub.",
      type: "grant"
    },
    {
      icon: <MapPin size={32} />,
      title: "Explore Local Resources",
      desc: "Uncover the creative spaces, studios, and resources hiding in your own backyard, dedicated to fueling your next project.",
      type: "map"
    }
  ];

  useEffect(() => {
    // 1. Observer for sticky scroll feature tracking
    const featureObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = Number(entry.target.getAttribute('data-index'));
            setActiveFeature(index);
          }
        });
      },
      { rootMargin: '-40% 0px -60% 0px' }
    );
    document.querySelectorAll('.feature-scroll-item').forEach((el) => featureObserver.observe(el));

    // 2. Observer for scroll animations (mockups sliding in)
    const animateObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          } else {
            entry.target.classList.remove('is-visible');
          }
        });
      },
      { rootMargin: '0px 0px -15% 0px' }
    );
    document.querySelectorAll('.mockup-animate').forEach((el) => animateObserver.observe(el));

    return () => {
      featureObserver.disconnect();
      animateObserver.disconnect();
    };
  }, []);

  return (
    <div className="landing-page min-vh-100 lp-wrapper">

      {/* 1. Floating Header */}
      <nav className="floating-header">
        <Link to="/" className="d-flex align-items-center">
          <img src={theme === 'dark' ? Logo : LogoLight} alt="Circuit Logo" id='mainNavLogo' />
        </Link>

        <div className="nav-links">
          <Link to="/opportunities" state={{ welcome: true }} className="nav-link">Explore Opportunities</Link>
          <Link to="/business" className="nav-link d-flex align-items-center gap-2">
            For Businesses <ArrowRight size={16} />
          </Link>
        </div>

        <div className="d-flex align-items-center gap-3">
          <Link to="/login" className="btn-custom-outline d-none d-sm-inline-block">Sign In</Link>
          <Link to="/createAccount" className="btn-custom-primary">Join Circuit</Link>
        </div>
      </nav>

      {/* 2. Hero Section */}
      <section className="hero-section text-center">
        <div className="hero-glow"></div>
        <div className="container position-relative" style={{ zIndex: 1 }}>
          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9">
              <h1 className="fw-bolder mb-4 d-flex flex-column justify-content-center align-items-center lp-hero-title">
                <span className="mb-2 lp-hero-plug-into">Plug into</span>
                <TypingEffect />
              </h1>
              <p className="mb-5 fs-4 px-md-5 fw-normal lp-hero-subtitle">
                The central hub for creatives to find grants, discover local resources, and build their next project together.
              </p>
              <div className="d-flex flex-column flex-sm-row justify-content-center gap-3 px-3 px-sm-0">
                <Link to="/opportunities" state={{ welcome: true }} className="btn-hero-primary shadow">
                  Explore Opportunities
                </Link>
                <Link to="/createAccount" className="btn-hero-outline">
                  Create Your Portfolio
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3. How It Works (Zig-Zag) */}
      <section className="zig-zag-section">
        <div className="container">
          <div className="text-center mb-5 pb-4 mockup-animate">
            <h2 className="fw-bolder mb-3 display-5">How It Works</h2>
            <p className="fs-4 text-muted">Your creative journey, simplified in three steps.</p>
          </div>

          <div className="zig-zag-step">
            <div className="zig-zag-img-container mockup-animate">
              <BentoMockup type="profile" className="mockup-img" />
            </div>
            <div className="zig-zag-text mockup-animate mockup-animate-delay-1">
              <div className="step-number">01</div>
              <h4 className="fw-bold mb-3 fs-2">Build Your Portfolio</h4>
              <p className="fs-5 lp-step-desc">
                Show off your best work and unique style. Create a dynamic profile that speaks for itself and attracts top collaborators and sponsors in the industry.
              </p>
            </div>
          </div>

          <div className="zig-zag-step reverse">
            <div className="zig-zag-img-container mockup-animate">
              <BentoMockup type="grant" className="mockup-img" />
            </div>
            <div className="zig-zag-text mockup-animate mockup-animate-delay-1">
              <div className="step-number">02</div>
              <h4 className="fw-bold mb-3 fs-2">Find Gigs & Grants</h4>
              <p className="fs-5 lp-step-desc">
                Browse a live, centralized dashboard of active opportunities tailored to your niche. Skip the noise and focus on high-value roles that match your skill set.
              </p>
            </div>
          </div>

          <div className="zig-zag-step mb-0">
            <div className="zig-zag-img-container mockup-animate">
              <BentoMockup type="collab" className="mockup-img" />
            </div>
            <div className="zig-zag-text mockup-animate mockup-animate-delay-1">
              <div className="step-number">03</div>
              <h4 className="fw-bold mb-3 fs-2">Collaborate & Create</h4>
              <p className="fs-5 lp-step-desc">
                Connect with a niche community to bring your vision to life. Share ideas, form teams, and build your next masterpiece with talented peers.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 4. Sticky Scroll Features */}
      <section className="sticky-scroll-section">
        <div className="container">
          <div className="text-center mb-5 pb-4 mockup-animate">
            <h2 className="fw-bolder mb-3 display-5">Everything You Need to Thrive</h2>
            <p className="fs-4 text-muted">Tools tailored for the creative professional.</p>
          </div>

          <div className="sticky-container">
            {/* Left Column: Sticky Images */}
            <div className="sticky-left d-none d-lg-block">
              {features.map((feat, idx) => (
                <BentoMockup
                  key={idx}
                  type={feat.type}
                  className={activeFeature === idx ? 'active' : 'inactive'}
                />
              ))}
            </div>

            {/* Right Column: Scrolling Text */}
            <div className="scroll-right">
              {features.map((feat, idx) => (
                <div key={idx} data-index={idx} className={`feature-scroll-item ${activeFeature === idx ? 'active' : 'inactive'}`}>
                  <div className="feature-icon-lg">
                    {feat.icon}
                  </div>
                  <h4 className="fw-bold mb-4 fs-2">{feat.title}</h4>
                  <p className="fs-5 lp-feature-desc">{feat.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 5. Business Escape Hatch */}
      <section className="py-6 text-center position-relative overflow-hidden lp-business-hatch mockup-animate">
        <div className="hero-glow lp-glow-center"></div>
        <div className="container position-relative lp-business-hatch-title">
          <h2 className="fw-bolder mb-4 display-5">Looking to hire creatives or promote a space?</h2>
          <p className="mb-5 fs-4 text-muted">
            Reach a curated network of local talent, promote your events, and list your resources on the Circuit.
          </p>
          <Link to="/business" className="btn-hero-outline lp-business-btn">
            Go to Business Portal <ArrowRight size={20} className="ms-2" />
          </Link>
        </div>
      </section>

      {/* 6. Footer */}
      <Footer />
    </div>
  );
}
